import SeasonalBanner, {
  SeasonalBannerColors,
} from "../../SeasonalBanner/SeasonalBanner"
import useStrings from "../../../localization/useStrings"
import svg from "../../../utils/svg"

const springColors: SeasonalBannerColors = {
  containerBackground: "linear-gradient(to bottom, #FFE1D8 0%, #F5CDC2 100%)",
  titleText: "#D5374C",
  subtitleText: "#58595B",
  urgencyText: "#58595B",
  countdownBox: "rgba(255, 255, 255, 0.8)",
  countdownValue: "#58595B",
  countdownLabel: "#58595B",
  ctaBackground: "#D5374C",
  ctaText: "white",
}

const SpringBanner = () => {
  const strings = useStrings()

  return (
    <SeasonalBanner
      icon={<svg.spring.SpringBanner />}
      title={strings.springSale.title}
      colors={springColors}
      titleFontSize="18px"
    />
  )
}

export default SpringBanner
